import { useCallback } from 'react';

import { useCms } from '~/components/hooks/useCms';
import { useCliveConfigOptions } from '~/components/SystemConfiguration/CliveConfiguration/CliveConfigurationContext';
import { type FnolInboxRecord, FnolInboxRecordFnolInboxStatus } from '~/server_shared/openapi/data-contracts';

import { AI_PROCESSING_STATUSES_SET } from '../utils';

export const useShouldDisplayCliveForInboxRecord = () => {
  const { userOrganization } = useCms();
  const { isCliveEnabled } = useCliveConfigOptions();

  return useCallback(
    (row: FnolInboxRecord) => {
      const isNoLobAndSubOrgStatus = row.status === FnolInboxRecordFnolInboxStatus.NoLobAndSubOrg;
      const isAiProcessingStatus = AI_PROCESSING_STATUSES_SET.has(row.status);

      if (isNoLobAndSubOrgStatus) {
        return row.is_clive_enabled_for_incident_configuration !== false;
      }

      if (isAiProcessingStatus) {
        if (userOrganization.sub_organizations_enabled) {
          return row.effective_sub_org_id ? isCliveEnabled(row.effective_sub_org_id) : false;
        } else {
          return true;
        }
      }

      return false;
    },
    [userOrganization.sub_organizations_enabled, isCliveEnabled]
  );
};
